<form>

  <div mat-dialog-content class="calibrates-theme">

    <div fxLayout="column" class="flexwrap">

      <div fxFlex>
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'calibrateEquipmentEdit.patterns.dialog.equipment.label' | translate }}</mat-label>
          <input matInput [ngModel]="data.item.name" #trigger="matAutocompleteTrigger" [matAutocomplete]="auto"
            (keyup)="lookupEquipment($event)" [ngModelOptions]="{standalone: true}" required>
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn"
            (optionSelected)="onSensorChange($event, trigger)">
            @for (item of equipmentAutoComplete; track item; let index = $index) {
              <mat-option [value]="item">
                {{ item.name}} ({{item.serialNum}})
              </mat-option>
            }
          </mat-autocomplete>
          <mat-error>
            {{ 'calibrateEquipmentEdit.patterns.dialog.equipment.error' | translate }}
          </mat-error>
        </mat-form-field>

        @if (data.item.idEquipment != null) {
          <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
            <div fxFlex="10" style="align-content: center;">
              <span>{{data.item.name}}</span>
            </div>
            <div fxFlex="5">
               <button mat-icon-button (click)="downloadPdf()">
                <mat-icon>cloud_download</mat-icon>
              </button>
            </div>
          </div>
         
        }
      </div>

      <div fxFlex>
        {{ 'calibrateEquipmentEdit.patterns.dialog.values.label' | translate }}
      </div>

      <div fxFlex>

        @for (value of data.item.values; track value; let indexValue = $index) {
          <div fxLayout="row" fxLayout.xs="column" class="flexwrap"
            >
            <div fxFlex="5" style="padding-top: 1em;">
              <mat-checkbox name="include{{indexValue}}" color="primary" [checked]="value.include"
                (change)="setValue(indexValue, $event, 'include')" [disabled]="data.item.name == null">
              </mat-checkbox>
            </div>
            <div fxFlex="10" fxFlex.lt-md="95%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'calibrateEquipmentEdit.patterns.dialog.values.number.label' | translate }}</mat-label>
                <input matInput name="num{{indexValue}}" [ngModel]="indexValue + 1" disabled>
              </mat-form-field>
            </div>
            <div fxFlex="15" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'calibrateEquipmentEdit.patterns.dialog.values.value.label' | translate }}</mat-label>
                <input matInput type="number" name="value{{indexValue}}" [ngModel]="value.value" disabled>
                <mat-error>
                  {{ 'calibrateEquipmentEdit.patterns.dialog.values.value.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="20" fxFlex.lt-md="100%">
              @if (!isNotUncertainty) {
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'calibrateEquipmentEdit.patterns.dialog.values.uncertainty.label' | translate }}</mat-label>
                  <input matInput type="number" name="uncertainty{{indexValue}}"  [ngModel]="value.uncertainty | smartNumber"
                    [disabled]="data.item.name == null || !value.include" required
                    (blur)="setValue(indexValue, $event.target.value, 'uncertainty')">
                  <mat-error>
                    {{ 'calibrateEquipmentEdit.patterns.dialog.values.uncertainty.error' | translate }}
                  </mat-error>
                </mat-form-field>
              }
            </div>
          </div>
        }

      </div>

    </div>

  </div>
  <div mat-dialog-actions class="calibrates-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()" cdkFocusInitial>{{ 'button.save' | translate
    }}</button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>